document.addEventListener("DOMContentLoaded", () => {

  const form = document.querySelector("form.cart__recap");
  if (!form) return;

  const checkbox = document.getElementById("agree_terms");
  const error = document.getElementById("agree_terms_error");
  const button = form.querySelector('button[name="checkout"]');

  if (!checkbox || !error || !button) return;

  function syncState() {
    const agreed = checkbox.checked;

    button.disabled = !agreed;
    error.hidden = agreed;

    if (agreed) {
      // 変数の上書きを解除し、テーマ本来の色(--primary-button-background等)に戻す
      button.style.removeProperty("--button-background");
      button.style.removeProperty("--button-text-color");
    } else {
      // カンマ区切りのRGB数値で指定する(HEXではなく数値のみ)
      button.style.setProperty("--button-background", "204, 204, 204");
      button.style.setProperty("--button-text-color", "136, 136, 136");
    }
  }

  syncState();

  checkbox.addEventListener("change", syncState);

  form.addEventListener("submit", function (event) {
    if (!checkbox.checked) {
      event.preventDefault();
      event.stopPropagation();
      syncState();
      checkbox.focus();
      return false;
    }
  });

  document.addEventListener("cart:updated", function () {
    checkbox.checked = false;
    syncState();
  });

  window.addEventListener("pageshow", syncState);

});